
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { messageToNativeClient } from '../../Common/utils/platformCommunicationUtil';
import { joinGameFromLeaderBoard, leaderBoardGamesList, setGameJoinCheckAck, setPlayerConsentDetails, setPlayerDetails, setRakebackGameDefinitions, updateConfigsPlayer, updateDisplayName, updateHomePageData, updateKycStatus, updateNotificationCount, updatePlayerBalance, updatePlayerRakebackLevel, updateRemindMeStatusToServer } from '@/Poker/redux/slices/lobbySlice';
import LobbyConnection from '@/Poker/io/LobbyConnection';
import TableUtils from '@/Poker/utils/TableUtils';

export default function PlatformServiceProvider({ children }) {
    const dispatch = useDispatch();
    const [versionMatch, setVersionMatch] = useState(false);

    useEffect(() => {
        const checkVersion = () => {
            let clientVersion = import.meta.env.VITE_REACT_APP_CLIENT_VERSION;

            try {
                if (window.XMLHttpRequest) {
                    let locationURL = new URL(window.location.href);
                    console.log("Location URL: ", locationURL);

                    let xmlRequest = new XMLHttpRequest();
                    xmlRequest.onreadystatechange = (Event) => {
                        if (Event.target.readyState === 4) {
                            let xmlDocument = xmlRequest.responseXML;
                            console.log("XML_DOCUMENT_RESPONSE", xmlDocument);
                            if (xmlDocument) {
                                let versionElement = xmlDocument.getElementsByTagName("version");
                                let version = versionElement[0].textContent;

                                if (version !== clientVersion) {
                                    console.warn(`Version mismatch: ${version} (in xml) vs ${clientVersion} (client). 
                                        Redirecting to the latest version...`);
                                    let redirectionURL = new URL(
                                        import.meta.env.VITE_REACT_APP_CLIENT_ORIGIN +
                                        import.meta.env.VITE_REACT_APP_CLIENT_URL_PATH_NAME +
                                        "index.html"
                                    );

                                    let locationURLSearchParams = new URLSearchParams(
                                        locationURL.search
                                    );
                                    locationURLSearchParams.set("t", Math.random()); //replaces the existing timestamp (if any)

                                    redirectionURL.search = locationURLSearchParams.toString(); //updates with the remaining (if any) search params
                                    redirectionURL.hash = locationURL.hash; //hash (if already exists) in URL to be added

                                    window.location.href = redirectionURL.href;
                                } else {
                                    console.log("Version match successful - " + version);
                                    setVersionMatch(true);
                                }
                            }
                        }
                    };

                    xmlRequest.open(
                        "GET",
                        import.meta.env.VITE_REACT_APP_CLIENT_ORIGIN +
                        import.meta.env.VITE_REACT_APP_CLIENT_URL_PATH_NAME +
                        "version.xml?t=" +
                        Math.random(),
                        true
                    );

                    xmlRequest.responseType = "document";
                    xmlRequest.send();
                }
            } catch (error) {
                console.log("Error at check version:", error);
            }
        };

        if (process.env.NODE_ENV === "production") {
            if (import.meta.env.VITE_REACT_APP_CHECK_VERSION === "true") {
                checkVersion();
                return;
            }
        }
        console.info(`Skipping version check - mode is ${process.env.NODE_ENV} and check version is ${import.meta.env.VITE_REACT_APP_CHECK_VERSION}`);
        setVersionMatch(true);
    }, [])

    useEffect(() => {
        if (!versionMatch) return;

        // Informing the platform that the app is loaded
        messageToNativeClient({ type: "appLoaded" });
        // Requesting the platform to send the token related data
        messageToNativeClient({ type: "token" });

        const dataFromPlatform = (event) => {
            let date = new Date();
            console.log(
                `Message from Platform ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}:${date.getMilliseconds()} >>> ${event.data
                }`
            );

            let data = event.data;
            try {
                data = JSON.parse(event.data);
            } catch (error) {
                console.log("Error at JSON parse dataFromPlatform:", error);
                data = undefined;
            }

            switch (data && data.type && data.type.toLowerCase()) {
                case "token":
                    const displayName = data.displayName || data.screenName;
                    if (displayName) {
                        // Updating the display name in the redux store
                        dispatch(updateDisplayName({ displayName: displayName }));
                        // Requesting the platform to send the balance related data
                    }

                    if (data.screenName && data.screenName !== "") {
                        dispatch(setPlayerDetails(data));
                        messageToNativeClient({
                            type: "getBalance",
                            token: data.body,
                        });
                        messageToNativeClient({ type: "homepage" });
                    }
                    break;
                case "balance":
                    dispatch(updatePlayerBalance(data));
                    break;
                case "logout":
                    messageToNativeClient({ type: "openLogout" });
                    break;
                case "remindmestatus":
                    dispatch(updateRemindMeStatusToServer({ ...data }));
                    break;
                case "playnowdata":
                    dispatch(joinGameFromLeaderBoard(data));
                    break;
                case "lbdata":
                    dispatch(leaderBoardGamesList(data));
                    break;
                case "plpclick":
                    break;
                case "myticket":
                    break;
                case "pokerrblogin":
                    dispatch(setRakebackGameDefinitions(data));
                    break;
                case "pokerrbchange":
                    dispatch(updatePlayerRakebackLevel(data));
                    break;
                case "internet":
                    LobbyConnection.getInstance().toggleEventBasedNetworkStatus();
                    TableUtils.getInstance().toggleEventBasedNetworkStatus();
                    break;
                case "useconsent":
                    dispatch(setPlayerConsentDetails(data));
                    break;
                case "gamejoincheckack":
                    dispatch(setGameJoinCheckAck(data));
                    break;
                case "homepage":
                    //console.log('Spruha log >>> Homepage data >>> ", data);
                    dispatch(updateHomePageData({ homeData: data }));
                    break;
                case "getNotifications":
                    dispatch(updateNotificationCount(data));
                    break;
                case "updateconfig":
                    dispatch(updateConfigsPlayer(data));
                    break;
                case "kycupdate":
                    dispatch(updateKycStatus(data));
                    break;
                case "logoutsuccess":
                    break;
                case "displayname":
                    dispatch(updateDisplayName({ displayName: data.displayName }));
                    break;
                default:
                    return null;
            }
        };

        window.addEventListener("dataToClient", dataFromPlatform);

        return () => {
            window.removeEventListener("dataToClient", dataFromPlatform);
        }
    }, [dispatch, versionMatch])

    return children;
}
